import classNames from "classnames";
import React, { ReactNode } from "react";
import styles from "./Text.module.scss";

type TextSize = "xs" | "sm" | "md" | "lg";
type TextType = "title" | "text" | "heading"; // Added "heading"

interface TextProps {
  size?: TextSize;
  type?: TextType;
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const Text: React.FC<TextProps> = ({
  size = "md",
  type = "text",
  children,
  className,
  style,
}) => {
  const combinedClassName = classNames(
    {
      [styles.textXs]: size === "xs",
      [styles.textSm]: size === "sm",
      [styles.textMd]: size === "md",
      [styles.textLg]: size === "lg",
      [styles.title]: type === "title",
      [styles.text]: type === "text",
      [styles.heading]: type === "heading", // Added new class for "heading"
    },
    className
  );

  return (
    <div style={style} className={combinedClassName}>
      {children}
    </div>
  );
};

export default Text;
